/**
 * Constructor method for creating instance of the header sub nav which is made visible
 * when the corresponding controller (headerNavItem) has focus
 *
 * Instance properties
 * - domNode : reference to domNode
 * - controller : reference to the controlling headerNavItem instance
 * - subNavItems : list of all navItems within the subNav
 * - firstChars : inventory of firstChars for identifying elements based on keypress
 * - firstItem : first headerNavItem within the subnav
 * - lastItem : last headerNavItem within the subnav
 * - hasFocus : flag to identify current focus
 * - hasHover : flag to identify current hover
 *
 * @param {Node} domNode DomNode for the header nav
 */
const HeaderSubNav = function (domNode, controllerObj) {
  this.domNode = domNode;
  this.controller = controllerObj;

  this.subNavItems = []; // See HeaderSubNav init method
  this.firstChars = []; // See HeaderSubNav init method

  this.firstItem = null; // See HeaderSubNav init method
  this.lastItem = null; // See HeaderSubNav init method

  this.hasFocus = false; // See MenuItem handleFocus, handleBlur
  this.hasHover = false; // See HeaderSubNav handleMouseover, handleMouseout
};

/*
 * Initializer for a HeaderSubNav instance
 *
 * Locate all navigation items (HeaderSubNavItems) within the SubNav which are links to external pages or products.
 * Push these items into a list and set the first/last items in the list
 *
 */
HeaderSubNav.prototype.init = function () {
  let textContent, numItems;
  const subMenuLinks = this.domNode.querySelectorAll(":scope a.page-link");
  const subMenuProducts = this.domNode.querySelectorAll(
    ":scope a.product-link"
  );

  this.domNode.addEventListener("mouseover", this.handleMouseover.bind(this));
  this.domNode.addEventListener("mouseout", this.handleMouseout.bind(this));

  subMenuLinks.forEach(function (nodeItem) {
    subNavItem = new HeaderSubNavItem(nodeItem, this);
    subNavItem.init();
    this.subNavItems.push(subNavItem);
    textContent = nodeItem.textContent.trim();
    this.firstChars.push(textContent.substring(0, 1).toLowerCase());
  }, this);

  subMenuProducts.forEach(function (nodeItem) {
    subNavItem = new HeaderSubNavItem(nodeItem, this);
    subNavItem.init();
    this.subNavItems.push(subNavItem);
    textContent = nodeItem.textContent.trim();
    this.firstChars.push(textContent.substring(0, 1).toLowerCase());
  }, this);

  // Use populated subNavItems array to initialize firstItem and lastItem.
  numItems = this.subNavItems.length;
  if (numItems > 0) {
    this.firstItem = this.subNavItems[0];
    this.lastItem = this.subNavItems[numItems - 1];
  }
  this.firstItem.domNode.tabIndex = 0;
};

/* EVENT HANDLERS */

HeaderSubNav.prototype.handleMouseover = function (event) {
  this.hasHover = true;
};

HeaderSubNav.prototype.handleMouseout = function (event) {
  this.hasHover = false;
  setTimeout(this.close.bind(this, false), 1);
};

/* FOCUS MANAGEMENT METHODS */

HeaderSubNav.prototype.setFocusToController = function (command, flag) {
  const focusCommand = typeof command === "string" ? command : "";

  if (focusCommand === "") {
    if (this.controller && this.controller.domNode) {
      this.controller.domNode.focus();
    }
    return;
  }

  if (focusCommand === "previous") {
    this.controller.headerNav.setFocusToPreviousItem(this.controller, flag);
  } else if (focusCommand === "next") {
    this.controller.headerNav.setFocusToNextItem(this.controller, flag);
  }
};

HeaderSubNav.prototype.setFocusToFirstItem = function () {
  this.firstItem.domNode.focus();
};

HeaderSubNav.prototype.setFocusToLastItem = function () {
  this.lastItem.domNode.focus();
};

HeaderSubNav.prototype.setFocusToPreviousItem = function (currentItem) {
  var index;
  if (currentItem === this.firstItem) {
    this.lastItem.domNode.focus();
  } else {
    index = this.subNavItems.indexOf(currentItem);
    this.subNavItems[index - 1].domNode.focus();
  }
};

HeaderSubNav.prototype.setFocusToNextItem = function (currentItem) {
  var index;

  if (currentItem === this.lastItem) {
    this.firstItem.domNode.focus();
  } else {
    index = this.subNavItems.indexOf(currentItem);
    this.subNavItems[index + 1].domNode.focus();
  }
};

HeaderSubNav.prototype.setFocusByFirstCharacter = function (currentItem, char) {
  var start,
    index,
    char = char.toLowerCase();

  // Get start index for search based on position of currentItem
  start = this.subNavItems.indexOf(currentItem) + 1;
  if (start === this.subNavItems.length) {
    start = 0;
  }

  // Check remaining slots in the menu
  index = this.getIndexFirstChars(start, char);

  // If not found in remaining slots, check from beginning
  if (index === -1) {
    index = this.getIndexFirstChars(0, char);
  }

  // If match was found...
  if (index > -1) {
    this.subNavItems[index].domNode.focus();
  }
};

HeaderSubNav.prototype.getIndexFirstChars = function (startIndex, char) {
  for (var i = startIndex; i < this.firstChars.length; i++) {
    if (char === this.firstChars[i]) {
      return i;
    }
  }
  return -1;
};

HeaderSubNav.prototype.open = function () {
  // Set CSS properties
  this.domNode.style.display = "flex";
  this.controller.domNode.parentNode.classList.add("active");
  this.controller.setExpanded(true);
};

HeaderSubNav.prototype.close = function (force) {
  var controllerHasHover = this.controller.hasHover;
  var hasFocus = this.hasFocus;

  if (!this.controller.isHeaderNavItem) {
    controllerHasHover = false;
  }

  if (force || (!hasFocus && !this.hasHover && !controllerHasHover)) {
    this.domNode.style.display = "none";
    this.controller.domNode.parentNode.classList.remove("active");
    this.domNode.style.zIndex = 0;
    this.controller.setExpanded(false);
  }
};
